import React from 'react'

export default function SectionDesc(props) {
  return (
    <h6 className='mt-1 text-lg sm:text-[28px] font-semibold max-w-[600px] mx-auto'>{props.desc}</h6>
  )
}
